// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Lib$PorterinFusionkitSentry from "../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as GeocodingApi$PorterinFeature from "../../geocode/domain/repo/GeocodingApi.mjs";
import * as ErrorConstants$PorterinFeature from "../constants/ErrorConstants.mjs";
import * as PlaceDetailsApi$PorterinFeature from "../../maps/PlaceDetailsApi.mjs";

function getAddressTypeDetail(place, address_type) {
  var detail = List.filter(function (curr) {
          return List.exists((function (current_type) {
                        return current_type === address_type;
                      }), curr.address_types);
        })(place);
  if (List.length(detail) !== 0) {
    return List.hd(detail).long_name;
  }
  
}

function setGeocodingAddress(geocode, form_on_change) {
  Curry._2(form_on_change, {
        landmark: geocode.formatted_address,
        location: geocode.geometry.location
      }, {
        pincode: getAddressTypeDetail(geocode.address_components, "postal_code"),
        state: getAddressTypeDetail(geocode.address_components, "administrative_area_level_1"),
        city: getAddressTypeDetail(geocode.address_components, "administrative_area_level_2"),
        locality: getAddressTypeDetail(geocode.address_components, "sublocality_level_1"),
        sub_locality: getAddressTypeDetail(geocode.address_components, "sublocality_level_2")
      });
}

function setDefaultAddress(msg, form_on_change) {
  Curry._2(form_on_change, {
        landmark: msg,
        location: {
          lat: 1000.0,
          lng: 1000.0
        }
      }, {
        pincode: undefined,
        state: undefined,
        city: undefined,
        locality: undefined,
        sub_locality: undefined
      });
}

function retryWithUpdatedPlaceId(place_id, form_on_change) {
  var mapInst = document.getElementById("map");
  PlaceDetailsApi$PorterinFeature.getUpdatedPlaceId(mapInst, place_id, (function (id) {
          GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(id, (function (geocode) {
                  setGeocodingAddress(geocode, form_on_change);
                }), (function (param) {
                  setDefaultAddress("Try again", form_on_change);
                }));
        }), (function (param) {
          Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorConstants$PorterinFeature.fetchPlaceIdError);
          setDefaultAddress("Try again", form_on_change);
        }));
}

function getAddressDetailsGeocode(place_id, form_on_change) {
  if (place_id === "") {
    return setDefaultAddress("Select from dropdown", form_on_change);
  } else {
    return GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(place_id, (function (geocode) {
                  setGeocodingAddress(geocode, form_on_change);
                }), (function (param) {
                  retryWithUpdatedPlaceId(place_id, form_on_change);
                }));
  }
}

function getAddressDetailsPlaceAutocomplete(place_id, form_on_change, recorded_address) {
  if (place_id === "") {
    return setDefaultAddress("Select from dropdown", form_on_change);
  } else {
    return GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(place_id, (function (geocode) {
                  Curry._2(form_on_change, {
                        landmark: recorded_address,
                        location: geocode.geometry.location
                      }, {
                        pincode: getAddressTypeDetail(geocode.address_components, "postal_code"),
                        state: getAddressTypeDetail(geocode.address_components, "administrative_area_level_1"),
                        city: getAddressTypeDetail(geocode.address_components, "administrative_area_level_2"),
                        locality: getAddressTypeDetail(geocode.address_components, "sublocality_level_1"),
                        sub_locality: getAddressTypeDetail(geocode.address_components, "sublocality_level_2")
                      });
                }), (function (_error) {
                  retryWithUpdatedPlaceId(place_id, form_on_change);
                }));
  }
}

export {
  getAddressTypeDetail ,
  setGeocodingAddress ,
  setDefaultAddress ,
  retryWithUpdatedPlaceId ,
  getAddressDetailsGeocode ,
  getAddressDetailsPlaceAutocomplete ,
}
/* Lib-PorterinFusionkitSentry Not a pure module */
